module.exports = __webpack_public_path__ + "83b1319831f44d3da3efbfa33672eda5.png";


//////////////////
// WEBPACK FOOTER
// ./work/sociallyfox/img/prez.png
// module id = 747
// module chunks = 0